import styled from '@emotion/styled';
import React, { useState } from 'react';
import { theme } from '../../../theme';
import { Icon } from '../../icon';
import { RadioCheck } from '../radio-check-input';
import { useField } from 'formik';
import { Pictogram } from '../../pictogram';
import { ChannelLogo } from '../../channel-logo';
export const StyledLabel = styled.label `
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: ${({ description }) => description ? 'flex-start' : 'center'};
	transition: all 120ms ease-in-out;
	border-radius: ${theme.radii.radii30};
	width: 100%;
	cursor: pointer;

	padding: ${({ variant }) => (variant === 'regular' ? '.75rem' : '1rem')};
	background-color: ${({ checked }) => checked ? theme.colors.BB10 : theme.colors.LM_NU10};

	color: ${({ checked }) => (checked ? theme.colors.BB100 : 'black')};

	outline: ${({ checked }) => checked
    ? `2px solid ${theme.colors.BB100}`
    : `1px solid ${theme.colors.LM_NU30}`};

	:hover {
		background-color: ${({ checked }) => checked ? theme.colors.BB20 : theme.colors.LM_NU20};
		outline: ${({ checked }) => checked
    ? `2px solid ${theme.colors.BB110}`
    : `2px solid ${theme.colors.LM_NU20}`};
	}

	:focus-within {
		background-color: ${({ checked }) => checked ? theme.colors.BB20 : theme.colors.LM_NU20};
		outline: 2px solid ${theme.colors.BB80};
	}

	margin-bottom: 1rem;
`;
const StyledSpan = styled.span `
	${theme.typography.IB100};
	flex-direction: column;
	display: flex;

	padding-left: ${({ icon }) => (icon ? '.5rem' : 0)};

	user-select: none;

	font-size: ${({ variant }) => (variant === 'regular' ? '1rem' : '1.25rem')};
	color: ${theme.colors.LM_NU100};
	line-height: 150%;

	// description
	span {
		${theme.typography.IR90};
		font-size: ${({ variant }) => variant === 'regular' ? '.75rem' : '1rem'};
	}
`;
const StyledIcon = styled(Icon) `
	display: flex;
	width: 24px;
	height: 24px;
	margin-top: ${({ variant }) => (variant === 'large' ? '2px' : 0)};

	align-items: ${({ description }) => (description ? 'inherit' : 'center')};
`;
const StyledImgContainer = styled.div `
	margin-right: ${theme.spacing.space20};
`;
export const EnhancedRadioCheckInput = (props) => {
    var _a;
    const { style, className, label, description, variant = 'regular', icon, pictogram, channelLogo, descriptionJsxContent, } = props;
    const [hovered, setHovered] = useState(false);
    const [field] = useField(props);
    return (React.createElement(StyledLabel, { checked: (_a = field.checked) !== null && _a !== void 0 ? _a : false, variant: variant, onMouseOver: () => setHovered(true), onMouseLeave: () => setHovered(false), description: Boolean(description), className: className, style: style },
        React.createElement("div", { style: { display: 'inherit' } },
            icon && (React.createElement(StyledIcon, { variant: variant, description: Boolean(description), name: icon, color: "inherit" })),
            pictogram && (React.createElement(StyledImgContainer, null,
                React.createElement(Pictogram, Object.assign({}, pictogram)))),
            channelLogo && (React.createElement(StyledImgContainer, null,
                React.createElement(ChannelLogo, Object.assign({}, channelLogo)))),
            React.createElement(StyledSpan, { variant: variant, icon: Boolean(icon) },
                label,
                descriptionJsxContent && descriptionJsxContent,
                (!descriptionJsxContent && description) && React.createElement("span", null,
                    " ",
                    description))),
        React.createElement(RadioCheck, Object.assign({}, props, { hovered: hovered, style: { display: 'block', position: 'relative' } }))));
};
//# sourceMappingURL=EnhancedRadioCheckInput.js.map